export default __webpack_public_path__ + "static/media/plain-sticker-ve.8412eb74.png";